import { useEffect, useState } from "react";
import { useNavigate, useLocation, Routes, Route, Navigate } from "react-router-dom";

import UserManagement from "./UserManagement";
import PromptManagement from "./PromptManagement";
import ProhibitedWords from "./ProhibitedWords";
import DraftSectionManagement from "./DraftSectionManagement";
import GeneralSettings from "./GeneralSettings";
import ApiManagement from "./ApiManagement";
import AddUser from "./AddUser";

import "../../styles/settings/Settings.css";

const Settings = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [active, setActive] = useState("users");

  /* 🔥 SYNC ACTIVE TAB WITH URL */
  useEffect(() => {
    if (location.pathname.includes("/users")) setActive("users");
    else if (location.pathname.includes("/add-user")) setActive("users");
    else if (location.pathname.includes("/api-management")) setActive("api");
    else if (location.pathname.includes("/prompts")) setActive("prompt");
    else if (location.pathname.includes("/draft-sections")) setActive("draftSection");
    else if (location.pathname.includes("/prohibited-words")) setActive("prohibited");
    else if (location.pathname.includes("/general-settings")) setActive("general");
  }, [location.pathname]);

  return (
    <div className="settings-wrapper">
      {/* ================= SIDEBAR ================= */}
      <div className="settings-sidebar">
        <h4>⚙ Settings</h4>

        <button
          className={active === "users" ? "active" : ""}
          onClick={() => navigate("/admin/settings/users")}
        >
          👤 User Management
        </button>

        <button
          className={active === "api" ? "active" : ""}
          onClick={() => navigate("/admin/settings/api-management")}
        >
          🔑 API Management
        </button>

        <button
          className={active === "prompt" ? "active" : ""}
          onClick={() => navigate("/admin/settings/prompts")}
        >
          💬 Prompt Management
        </button>

        <button
          className={active === "draftSection" ? "active" : ""}
          onClick={() => navigate("/admin/settings/draft-sections")}
        >
          📄 Draft Section Management
        </button>

        <button
          className={active === "prohibited" ? "active" : ""}
          onClick={() => navigate("/admin/settings/prohibited-words")}
        >
          🚫 Prohibited Words Management
        </button>

        <button
          className={active === "general" ? "active" : ""}
          onClick={() => navigate("/admin/settings/general-settings")}
        >
          ⚙️ General Settings
        </button>
      </div>

      {/* ================= CONTENT ================= */}
      <div className="settings-content">
        {/* 🔥 SINGLE ALIGNMENT WRAPPER */}
        <div className="settings-page">
          <Routes>
            <Route index element={<Navigate to="users" />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="add-user" element={<AddUser />} />
            <Route path="api-management" element={<ApiManagement />} />
            <Route path="prompts" element={<PromptManagement />} />
            <Route path="draft-sections" element={<DraftSectionManagement />} />
            <Route path="prohibited-words" element={<ProhibitedWords />} />
            <Route path="general-settings" element={<GeneralSettings />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default Settings;
